import { createContext, useContext } from 'react';

import { FormSettings, Maybe } from '@/graphql/generated';

const DEFAULT_MAX_ADDITIONAL_DOCS_ALLOWED = 2;

export const JobApplicationFormSettingsContext = createContext<Maybe<FormSettings> | undefined>(undefined);

export const useDisableAdditionalComments = (): boolean => {
  const formSettings = useContext(JobApplicationFormSettingsContext);

  return formSettings?.disableAdditionalComments ?? false;
};

export const useShowAdditionalDocs = (): boolean => {
  const formSettings = useContext(JobApplicationFormSettingsContext);

  const allowedAdditionalDocs = formSettings?.maxAdditionalDocuments ?? DEFAULT_MAX_ADDITIONAL_DOCS_ALLOWED;

  return allowedAdditionalDocs >= DEFAULT_MAX_ADDITIONAL_DOCS_ALLOWED;
};

export const useFormSettingsTrackingData = (): string => {
  const formSettings = useContext(JobApplicationFormSettingsContext);

  return `max_additional_documents_${
    formSettings?.maxAdditionalDocuments ?? DEFAULT_MAX_ADDITIONAL_DOCS_ALLOWED
  },disable_comments_${formSettings?.disableAdditionalComments ?? false}`;
};
